import React from 'react'
import { calloutStyle as styles } from './callout.tailwind'

const Callout = () => {
  const stats = [
    {
      number: "1.2M+",
      label: "PATIENT VISITS ANNUALLY",
    },
    {
      number: "1,200+",
      label: "SPECIALISTS DEDICATED TO KIDS",
    },
    {
      number: "100%",
      label: "FOCUSED ON PEDIATRIC CARE",
    },
  ]

  return (
    <section className={styles.section_wrapper}>
      {/* Heading */}
      <h2 className={styles.heading}>
        YOUR DOLLARS SUPPORT PEDIATRIC CARE AT
        <span className={styles.highlight}> CHILDREN'S HEALTHCARE OF ATLANTA.</span>
      </h2>

      {/* Divider */}
      <div className={styles.divider} />

      {/* Stats Container */}
      <div className={styles.stats_container}>
        {stats.map((stat, index) => (
          <div key={index} className={styles.stat_item}>
            <span className={styles.stat_number}>{stat.number}</span>
            <span className={styles.stat_label}>{stat.label}</span>
          </div>
        ))}
      </div>
    </section>
  )
}

export default Callout

